import { render, staticRenderFns } from "./VictimsQuestionModal.vue?vue&type=template&id=afc573b4&scoped=true&"
import script from "./VictimsQuestionModal.vue?vue&type=script&lang=js&"
export * from "./VictimsQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./VictimsQuestionModal.vue?vue&type=style&index=0&id=afc573b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc573b4",
  null
  
)

export default component.exports